import Footer from '../../../navigation/footerContainer';
import ChatContainer from './chatContainer';


export default function ChatPage (){
    return(
        <>
            <ChatContainer />
            <Footer />
        </>
    )
}